<script lang="ts">
	import { fade } from "svelte/transition"

	interface Props {
		strokeColor?: string
	}

	let { strokeColor = "var(--color-bg-opaque)" }: Props = $props()
</script>

<svg
	width="16"
	height="16"
	viewBox="0 0 16 16"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	in:fade={{ duration: 150 }}
	out:fade={{ duration: 150 }}
>
	<g clip-path="url(#clip0_431_2)">
		<path
			d="M9.81885 11.772C9.11589 13.3755 6.83763 13.3657 6.14854 11.7562L1.10628 -0.0213741L14.9626 0.038412L9.81885 11.772Z"
			class="svg-gill"
			fill={strokeColor}
		/>
	</g>
</svg>

<style>
</style>
